export default {
      id: "arrow-down-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "img/icons.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }